document.addEventListener('DOMContentLoaded', () => {
  /* Presentkort: uppdatera prisrad vid val av belopp */
  document.querySelectorAll('[data-amt-group]').forEach(g => g.addEventListener('click', e => {
    const b = e.target.closest('button'); if (!b) return;
    const gc = g.closest('.gc'); const p = gc && gc.querySelector('[data-amt-price]');
    if (p && b.dataset.price) p.textContent = b.dataset.price;
  }));
  /* Mailchimp inline-anmälan (JSONP) */
  document.addEventListener('submit', e => {
    const f = e.target.closest && e.target.closest('.mc-form'); if (!f) return;
    e.preventDefault();
    const msg = f.querySelector('.mc-msg');
    const params = new URLSearchParams(new FormData(f)).toString();
    const cb = 'mcCb' + Date.now();
    const s = document.createElement('script');
    window[cb] = d => {
      const ok = d && d.result === 'success';
      const txt = ok ? 'Tack — kolla din mejl för att bekräfta anmälan!'
        : ((d && d.msg ? d.msg.replace(/<[^>]+>/g, '').replace(/^\d+\s*-\s*/, '') : '') || 'Något gick fel, försök igen.');
      if (msg) { msg.textContent = txt; msg.className = 'mc-msg ' + (ok ? 'ok' : 'err'); }
      if (ok) f.reset();
      delete window[cb]; s.remove();
    };
    s.src = f.getAttribute('action').replace('/post?', '/post-json?') + '&' + params + '&c=' + cb;
    document.body.appendChild(s);
  });
  /* deltagarfält (köp åt någon annan) */
  document.querySelectorAll('[data-lp-toggle]').forEach(t => t.addEventListener('change', () => {
    const f = t.closest('.lineprops').querySelector('.lp-fields'); if (f) f.hidden = !t.checked;
  }));
  /* scroll-reveal */
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .12 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  /* hamburgermeny (mobil) */
  const burger = document.querySelector('[data-menu-toggle]');
  const panel = document.querySelector('[data-menu-panel]');
  if (burger && panel) {
    burger.addEventListener('click', () => {
      const open = panel.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open);
      panel.setAttribute('aria-hidden', !open);
      document.body.classList.toggle('menu-open', open);
    });
    panel.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      panel.classList.remove('open'); burger.classList.remove('open');
      document.body.classList.remove('menu-open');
    }));
  }

  /* belopps-knappar (presentkort) → väljer belopp/variant */
  document.querySelectorAll('[data-amt-group]').forEach(group => {
    group.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
      group.querySelectorAll('button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      if (b.dataset.variant) {
        const form = b.closest('form');
        const id = form && form.querySelector('[name=id]');
        if (id) id.value = b.dataset.variant;
      }
    }));
  });

  /* bilder/lista-växlare */
  document.querySelectorAll('[data-toggle]').forEach(group => {
    const btns = group.querySelectorAll('.toggle button');
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => x.classList.remove('on')); b.classList.add('on');
      group.querySelectorAll('.course-view').forEach(v => v.classList.remove('active'));
      const t = group.querySelector('#view' + b.dataset.v);
      if (t) t.classList.add('active');
    }));
  });

  /* kvantitets-stegare (stödjer flera på samma sida) */
  document.querySelectorAll('[data-q]').forEach(b => b.addEventListener('click', () => {
    const wrap = b.closest('.qty'); if (!wrap) return;
    const n = wrap.querySelector('[data-qn]'); if (!n) return;
    let v = parseInt(n.textContent, 10) || 1;
    v += b.dataset.q === '+' ? 1 : -1; if (v < 1) v = 1;
    n.textContent = v;
    const inp = wrap.querySelector('input[name=quantity]'); if (inp) inp.value = v;
  }));

  /* chip-väljare → uppdaterar dolt fält */
  document.querySelectorAll('[data-chip-group]').forEach(set => {
    const input = set.parentElement.querySelector('[data-chip-input]');
    set.querySelectorAll('.chooser').forEach(c => c.addEventListener('click', () => {
      set.querySelectorAll('.chooser').forEach(x => x.classList.remove('on'));
      c.classList.add('on'); if (input) input.value = c.dataset.val || c.textContent.trim();
    }));
  });

  /* kalenderval */
  document.querySelectorAll('#cal .free').forEach(d => d.addEventListener('click', () => {
    document.querySelectorAll('#cal .sel').forEach(x => x.classList.remove('sel'));
    d.classList.add('sel');
    const txt = d.textContent + ' juni 2026';
    const lbl = document.getElementById('seltime'); if (lbl) lbl.textContent = txt + ' · vi föreslår tider';
    const inp = document.getElementById('seltimeInput'); if (inp) inp.value = txt;
  }));

  /* varukorg: AJAX-tillägg + notis */
  const overlay = document.getElementById('cartModal');
  function closeModal() { if (overlay) { overlay.classList.remove('show'); overlay.setAttribute('aria-hidden', 'true'); } }
  if (overlay) {
    overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
    overlay.querySelectorAll('[data-close-modal]').forEach(b => b.addEventListener('click', closeModal));
  }
  function updateCount(c) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = c; el.hidden = c === 0; });
    const link = document.getElementById('cartModalCount'); if (link) link.textContent = 'Visa min varukorg (' + c + ')';
  }
  const form = document.querySelector('[data-product-form]');
  if (form) {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[data-add]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Lägger till…'; }
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: form.querySelector('[name=id]').value, quantity: parseInt((qInput || {}).value || 1, 10) }) });
        const item = await res.json();
        const cart = await (await fetch('/cart.js')).json();
        updateCount(cart.item_count);
        const wrap = document.getElementById('cartModalItem');
        if (wrap) {
          wrap.innerHTML = (item.image ? '<img src="' + item.image + '" alt="">' : '') + '<p>' + (item.product_title || item.title) + '</p>';
        }
        if (overlay) { overlay.classList.add('show'); overlay.setAttribute('aria-hidden', 'false'); }
      } catch (err) {
        form.submit();
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Lägg i varukorgen'; }
      }
    });
  }
});
